import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function StaticPages() {
  const pages = [{
    id: 1,
    title: 'About Us',
    text: 'Learn about our history...',
    param: 'about-us'
  }, {
    id: 2,
    title: 'Privacy Policy',
    text: 'Your privacy matters...',
    param: 'privacy'
  }, {
    id: 3,
    title: 'Terms of Service',
    text: 'Please read carefully...',
    param: 'terms'
  }];
  return <div className="space-y-6" data-id="element-795">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-796">Static Pages</h1>

      <Card className="overflow-hidden" data-id="element-797">
        <div className="overflow-x-auto" data-id="element-798">
          <table className="w-full text-sm text-left" data-id="element-799">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-800">
              <tr data-id="element-801">
                <th className="px-4 py-3" data-id="element-802">Title</th>
                <th className="px-4 py-3" data-id="element-803">Text</th>
                <th className="px-4 py-3" data-id="element-804">Param</th>
                <th className="px-4 py-3" data-id="element-805">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-806">
              {pages.map(page => <tr key={page.id} className="hover:bg-slate-50" data-id="element-807">
                  <td className="px-4 py-3 font-medium" data-id="element-808">{page.title}</td>
                  <td className="px-4 py-3 text-slate-500 truncate max-w-xs" data-id="element-809">
                    {page.text}
                  </td>
                  <td className="px-4 py-3 font-mono text-xs" data-id="element-810">{page.param}</td>
                  <td className="px-4 py-3" data-id="element-811">
                    <div className="flex items-center gap-2" data-id="element-812">
                      <Button variant="ghost" size="icon" title="View" data-id="element-813">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-814" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Edit" data-id="element-815">
                        <Edit className="h-4 w-4 text-blue-600" data-id="element-816" />
                      </Button>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-817">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-818" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}